import React, { useState, useEffect,useRef } from "react";
import { FaTrashAlt, FaPlus, FaEdit } from "react-icons/fa";
import { getUserInfo } from "../../../services/authService-sighup";
import Dialog from "../FormDialog/Dialog";
import AssetDetails from "./AssetDetails";
import { COMPANY_TAB } from "../constants/constants";

interface CompanyFormProps {
  onCreateCompany: (company: any) => void;
  onUpdateCompany: (company: any) => void;
  selectedCompany?: any;
  onClearSelection: () => void;
  onDirtyChange: (dirty: boolean) => void;
  onModeChange: (mode: 'create' | 'edit' | 'view' | null) => void;
  registerTabSwitchGuard?: (guard: () => boolean | Promise<boolean>) => void;
  onDeleteCompany: (companyId: string) => void;
  canDelete?: boolean;
}

const CompanyForm: React.FC<CompanyFormProps> = ({
  onCreateCompany,
  onUpdateCompany,
  selectedCompany,
  onClearSelection,
  onDirtyChange,
  onModeChange,
  registerTabSwitchGuard,
  onDeleteCompany,
  canDelete = false,
}) => {
  const [company_name, setCompany_name] = useState<string>("");
  const [owner_name, setOwner_name] = useState<string>("");
  const [company_id, setCompany_id] = useState<string>("");
  const [clientDomain, setClientDomain] = useState<string>("");
  const [domain_names, setDomain_names] = useState<string[]>([]);
  const [selectedAsset, setSelectedAsset] = useState<string>("");
  const [assetPercentage, setAssetPercentage] = useState<string>("");
  const [assets, setAssets] = useState<{ asset_id: number;asset_name:string;percent_ownership: string }[]>([]);
  const [user, setUser] = useState<{ fullName: string; email: string } | null>(null);
  const [isEditMode, setIsEditMode] = useState<boolean>(false);
  const [activeField, setActiveField] = useState<string | null>(null);
  const [isViewMode, setIsViewMode] = useState(false);
  const [modifiedFields, setModifiedFields] = useState<Record<string, boolean>>({});

  
  
  
  const [allAssets] = useState<{ asset_id: number; asset_name: string }[]>([]);
  const [errors, setErrors] = useState({
      company_name: false,
    });



  const [dialog, setDialog] = useState<{
    open: boolean;
    title: string;
    message: string;
    confirmButtonText: string;
    cancelButtonText?: string;
    onConfirm: () => void;
    onCancel?: () => void;
  }>({
    open: false,
    title: "",
    message: "",
    confirmButtonText: "",
    onConfirm: () => { },
  });


  useEffect(() => {
    const fetchUserInfo = () => {
      const userInfo = getUserInfo();
      if (userInfo) {
        setUser({
          fullName: userInfo.fullName || "Unknown User",
          email: userInfo.email || "",
        });
      }
    };
    fetchUserInfo();
  }, []);

  useEffect(() => {
    if (selectedCompany&& !isEditMode) {
      setCompany_name(selectedCompany.company_name || "");
      setOwner_name(selectedCompany.owner_name || "");
      setDomain_names(selectedCompany.domain_names || []);
      setAssets(selectedCompany.assets || []);
      setCompany_id(selectedCompany.company_id);
      // setIsEditMode(false); 
      setIsViewMode(true);
      onDirtyChange(false); 
    }  else if (selectedCompany && isEditMode) {
      // clearForm();
      setCompany_name(selectedCompany.company_name || "");
      setOwner_name(selectedCompany.owner_name || "");
      setDomain_names(selectedCompany.domain_names || []);
      setAssets(selectedCompany.assets || []);
      setCompany_id(selectedCompany.company_id);
      setIsEditMode(false);
      setIsViewMode(true);
    }
  }, [selectedCompany]);
  

  const clearForm = () => {
    setCompany_name("");
    setOwner_name("");
    setDomain_names([]);
    setAssets([]);
    setClientDomain("");
    setSelectedAsset("");
    setAssetPercentage("");
    setIsEditMode(false);
    setIsViewMode(false);
    onDirtyChange(false); 
    onModeChange(null);
    // onClearSelection();
  };

  const handleSave = () => {
    const isValid = validateFields();
    if (!isValid) {
      setDialog({
        open: true,
        title: COMPANY_TAB.VALIDATION.MISSING_INFO_TITLE,
        message: COMPANY_TAB.VALIDATION.MISSING_INFO_MESSAGE,
        confirmButtonText: "Close",
        onConfirm: closeDialog,
      });
      return;
    }
    const createdBy = user ? `${user.email || user.fullName}` : "Unknown User";
    const modifiedBy = user ? `${user.email || user.fullName}` : "Unknown User";

    if (!selectedCompany) {
     
      onCreateCompany({
        company_name,
        owner_name,
        domain_names,
        assets,
        relationship_type_code: "Owner",
        sys_created_by: createdBy,
        sys_modified_by: modifiedBy,
      });
    } else {
     
          onUpdateCompany({
            company_name,
            owner_name,
            domain_names,
            assets,
            company_id:company_id,
            relationship_type_code: "Owner",
            sys_created_by: createdBy,
            sys_modified_by: modifiedBy,
          });
    }
    onDirtyChange(false);
    setIsEditMode(false);
    clearForm();
  };

  const handleNew = () => {
    setDialog({
      open: true,
      title: COMPANY_TAB.DIALOGS.CONFIRM_NEW_TITLE,
      message: COMPANY_TAB.DIALOGS.CONFIRM_NEW_MESSAGE,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      onConfirm: () => {
        clearForm();
        // onModeChange('create');
        onDirtyChange(false);
        setIsEditMode(false);
        onClearSelection();
        closeDialog();
        setIsEditMode(false);

      },
      onCancel: closeDialog,
    });
  };

  const handleEdit = () => {
    setIsViewMode(false);
    setIsEditMode(true);
    onDirtyChange(true);
    setModifiedFields({});
  };

  const handleAddDomain = () => {
    if (clientDomain.trim()) {
      setDomain_names((prevDomains) => [...prevDomains, clientDomain.trim()]);
      setClientDomain("");
      setModifiedFields({});
    }
  };

  const handleDeleteDomain = (domain: string) => {
    setDomain_names((prevDomains) => prevDomains.filter((item) => item !== domain));
  };
  const resetToSelectedCompany = () => {
    if (selectedCompany) {
      setCompany_name(selectedCompany.company_name || "");
      setOwner_name(selectedCompany.owner_name || "");
      setDomain_names(selectedCompany.domain_names || []);
      setAssets(selectedCompany.assets || []);
      setCompany_id(selectedCompany.company_id);
      setIsEditMode(false);
      setIsViewMode(true);
      onDirtyChange(false);
      setModifiedFields({});
      onModeChange("view");
    }
  };
  
  const handleCancelClick = () => {
    setDialog({
      open: true,
      title: "Cancel Editing?",
      message: "Are you sure you want to discard changes?",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      onConfirm: () => {
        closeDialog();
        resetToSelectedCompany(); 
        setModifiedFields({});
      },
      onCancel: closeDialog,
    });
  };
  
  const handleAddAsset = () => {
    const asset = allAssets.find((a) => a.asset_id === Number(selectedAsset));
    
    if (asset) {
      setAssets((prevAssets) => [
        ...prevAssets,
        {
          asset_id: asset.asset_id,
          asset_name: asset.asset_name,
          percent_ownership: assetPercentage,
        },
      ]);
      setSelectedAsset('');
      setAssetPercentage('');
    }
  };
  
  
 
  const closeDialog = () => {
    setDialog({ open: false, title: "", message: "", confirmButtonText: "", onConfirm: () => { } });
  };
  const validateFields = () => {
    const newErrors = {
      company_name: company_name.trim() === "",
    };
  
    setErrors(newErrors);
    return !Object.values(newErrors).some((error) => error);
  };

  const handleDeleteClick = () => {
    if (!selectedCompany) return;
  
    setDialog({
      open: true,
      title: "Confirm Delete",
      message: `Are you sure you want to delete "${selectedCompany.company_name}"?`,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      onConfirm: () => {
        onDeleteCompany(selectedCompany.company_id);
        closeDialog();
        clearForm();
      },
      onCancel: closeDialog,
    });
  };

  return (
    <div className="font-poppins w-full max-w-6xl mx-auto p-6 bg-white rounded-lg shadow-md">
      {/* Dialog Component */}
      {dialog.open && (
        <Dialog
          title={dialog.title}
          message={dialog.message}
          onClose={closeDialog}
          onConfirm={dialog.onConfirm}
          onCancel={dialog.onCancel}
          confirmButtonText={dialog.confirmButtonText}
          cancelButtonText={dialog.cancelButtonText}
        />
      )}

<div className="flex justify-between items-center gap-3 mb-4">

<div>
  {isEditMode && canDelete && (
    <button
      onClick={handleDeleteClick}
      type="button"
      className="flex items-center gap-2 px-4 py-2 bg-red-500 text-white font-medium rounded-lg hover:bg-red-600"
    >
      <FaTrashAlt />
      Delete
    </button>
  )}
</div>

<div className="flex gap-3">
        {selectedCompany ? (
  <>
    {!isEditMode ? (
      <>
        <button
          onClick={handleNew}
          className="flex items-center gap-2 px-4 py-2 bg-[#a6a9ac] text-white font-medium rounded-lg hover:bg-gray-600 transition-colors duration-300 shadow-md transform hover:scale-105"
        >
          <FaPlus className="mr-2" /> New
        </button>
        <button
          onClick={handleEdit}
          disabled={isEditMode}
          className={`flex items-center gap-2 px-4 py-2 bg-[#a6a9ac] text-white font-medium rounded-lg hover:bg-gray-600 transition-colors duration-300 shadow-md transform hover:scale-105 ${isEditMode ? 'opacity-50 cursor-not-allowed' : ''}`}
        >
          <FaEdit className="mr-2" /> Edit
        </button>
      </>
    ) : (
      <>
        <button
          onClick={() => {
            setDialog({
              open: true,
              title: COMPANY_TAB.DIALOGS.CONFIRM_EDIT_TITLE,
              message: COMPANY_TAB.DIALOGS.CONFIRM_EDIT_MESSAGE,
              confirmButtonText: "Yes",
              cancelButtonText: "No",
              onConfirm: () => {
                closeDialog();
                handleSave();
                setModifiedFields({});
              },
              onCancel: closeDialog,
            });
          }}
          className="flex items-center gap-2 px-4 py-2 bg-[#a6a9ac] text-white font-medium rounded-lg hover:bg-gray-600 transition-colors duration-300 shadow-md transform hover:scale-105"
        >
          <FaPlus className="w-4 h-4" /> Save
        </button>
        
      <button
  onClick={handleCancelClick}
  className="flex items-center gap-2 px-4 py-2 bg-[#a6a9ac] text-white font-medium rounded-lg hover:bg-gray-600 transition-colors duration-300 shadow-md transform hover:scale-105"
>
   Cancel
</button>


      </>
    )}
  </>
) : (
  <button
    onClick={() => {
      const isValid = validateFields();
      if (!isValid) {
        setDialog({
          open: true,
          title: COMPANY_TAB.VALIDATION.MISSING_INFO_TITLE,
          message: COMPANY_TAB.VALIDATION.MISSING_INFO_MESSAGE,
          confirmButtonText: "Close",
          onConfirm: closeDialog,
        });
        return;
      }

      setDialog({
        open: true,
        title: COMPANY_TAB.DIALOGS.CONFIRM_CREATE_TITLE,
        message: COMPANY_TAB.DIALOGS.CONFIRM_CREATE_MESSAGE,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        onConfirm: () => {
          closeDialog();
          handleSave();
        },
        onCancel: closeDialog,
      });
    }}
    className="flex items-center gap-2 px-4 py-2 bg-[#a6a9ac] text-white font-medium rounded-lg hover:bg-[#474747] transition-colors duration-300"
  >
    <FaPlus className="mr-2" />
    Create
  </button>
)}

      </div>
      </div>

      {/* <div className="grid grid-cols-1 lg:grid-cols-2 gap-6"> */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-1 xl:flex xl:flex-col">
        <div className="space-y-6">
          {/* Company Name */}
          <div>
  <label className="block text-gray-600 mb-2 font-medium">Company Name<span className="text-red-500 text-lg align-top ml-1">*</span></label>
  <input
    type="text"
    value={company_name}
    // onChange={(e) => setCompany_name(e.target.value)}
    onChange={(e) => {
      setCompany_name(e.target.value);
      onDirtyChange(true); 
      setModifiedFields(prev => ({ ...prev, company_name: true }));
    }}
    placeholder="Enter company name"
    onFocus={() => setActiveField("company_name")}
    disabled={!isEditMode && selectedCompany}
    className={`w-full p-3 border rounded-lg shadow-inner text-sm transition-all duration-200  
    ${errors.company_name && !company_name
      ? "border-red-500 focus:ring-red-500"
      : isEditMode && (activeField === "company_name"|| modifiedFields.company_name)
        ? "border-green-500 focus:ring-2 focus:ring-green-500"
      : !isEditMode
        ? "bg-[#f9f9f9] text-gray-800 border-gray-300"
        : "bg-white text-black border-blue-500 focus:ring-2 focus:ring-blue-500"
    }`}
  />
</div>

          {/* Company Code */}
          <div>
            <label className="block text-gray-600 mb-2 font-medium">Owner Name</label>
            <input
              type="text"
              value={owner_name}
              // onChange={(e) => setOwner_name(e.target.value)}
              onChange={(e) => {
                setOwner_name(e.target.value);
                onDirtyChange(true); 
                setModifiedFields(prev => ({ ...prev, owner_name: true }));
              }}
              placeholder="Enter Owner Name"
              // disabled={true && selectedCompany}
              onFocus={() => setActiveField("owner_name")}
              disabled={!isEditMode && selectedCompany}
              className={`w-full p-3 border rounded-lg shadow-inner text-sm transition-all duration-200  
              ${!isEditMode
                  ? "bg-[#f9f9f9] text-gray-800 border-gray-300"
                  : isEditMode && (activeField === "owner_name"|| modifiedFields.owner_name)
                    ? "border-green-500 focus:ring-2 focus:ring-green-500"
                    : "bg-white text-black border-blue-500 focus:ring-2 focus:ring-blue-500"
              }`}
            />
          </div>        
        </div>

        {/* AssetDetails Component */}
        <AssetDetails
          selectedAsset={selectedAsset}
          setSelectedAsset={setSelectedAsset}
          assetPercentage={assetPercentage}
          setAssetPercentage={setAssetPercentage}
          assets={assets}
          setAssets={setAssets}
          handleAddAsset={handleAddAsset}
          disabled={!isEditMode && selectedCompany}
          onFocus={(fieldName) => setActiveField(fieldName)}
          modifiedFields={modifiedFields} 
          setModifiedFields={setModifiedFields} 
          highlightClass={
            !isEditMode
              ? "bg-[#f9f9f9] text-gray-800 border border-gray-300"
              : isEditMode && (activeField === "selectedAsset" || activeField === "assetPercentage"|| modifiedFields?.selectedAsset || modifiedFields?.assetPercentage)
                ? "border-2 border-green-500 focus:ring-2 focus:ring-green-500 bg-white text-black"
                : "border border-blue-500 focus:ring-2 focus:ring-blue-500 bg-white text-black"
          }       
        />
          {/* Client Domain */}
         <div className="p-4 bg-[#f9f9f9] border border-gray-300 gap-2 mt-8 rounded-lg shadow-sm">
            <label className="block text-gray-600 mb-4 font-medium text-lg">Add Client Domain</label>
            <div className="relative mb-4">
              <input
               onFocus={() => setActiveField("clientDomain")}
               type="text"
               value={clientDomain}
               // onChange={(e) => setClientDomain(e.target.value)}
               onChange={(e) => {
                 setClientDomain(e.target.value);
                 onDirtyChange(true); 
                 setModifiedFields(prev => ({ ...prev, clientDomain: true }));

               }}
               placeholder="Enter domain"
               className={`w-full p-3 border rounded-lg shadow-inner text-sm transition-all duration-200  
               ${!isEditMode
                   ? "bg-[#f9f9f9] text-gray-800 border-gray-300"
                   : isEditMode && (activeField === "clientDomain"|| modifiedFields.clientDomain)
                     ? "border-green-500 focus:ring-2 focus:ring-green-500"
                     : "bg-white text-black border-blue-500 focus:ring-2 focus:ring-blue-500"
               }`}
               
                
              />
              <button
                onClick={handleAddDomain}
                disabled={domain_names.length >= 100}
                className={`absolute top-2.5 right-2 px-4 py-1 rounded-full text-sm font-medium text-white ${domain_names.length >= 100
                  ? "bg-gray-400 cursor-not-allowed"
                  : "bg-[#a6a9ac] hover:bg-[#666769]"}`}
              >
                Add
              </button>
            </div>

            <div className="h-40 overflow-y-auto border border-gray-200 p-3 rounded-lg shadow-sm bg-white">
              
              {domain_names.map((domain_names, index) => (
                <div
                  key={index}
                  // className="flex items-center justify-between p-2 hover:bg-gray-100 rounded-lg"
                  className="flex items-center justify-between p-2 hover:bg-gray-100 rounded-lg gap-2 w-full max-w-[290px] ultra:max-w-[900px]"
                >
                   <span className="text-gray-800">{domain_names}</span>
                  <button
                    onClick={() => handleDeleteDomain(domain_names)}
                    className="text-gray-500 hover:text-red-700"
                    disabled={!isEditMode} // Only allow deleting in edit mode
                  >
                    <FaTrashAlt />
                  </button>
                </div>
              ))}
            </div>
          </div>
      </div>
    </div>
  );
};

export default CompanyForm;
